import cateringActions from './actions';
import getters from './getters';
import cateringMutations from './mutations';
import storeResourceFactory from '../../libs/storeResourceFactory';
import { cateringSettingsDefaults } from '@/constants';

const { OFFICE, EVENT, DIETS } = cateringSettingsDefaults;

const cateringStore = storeResourceFactory('catering', {
  pinCode: null,
  settings: {
    settings: {
      meal: DIETS,
      office: OFFICE,
      event: EVENT,
    },
    error: null,
  },
  data: {
    users: [],
    mealsInfo: [],
  },
});

const usersStore = storeResourceFactory('users', []);

const state = {
  ...cateringStore.state,
  ...usersStore.state,
};

const actions = {
  ...cateringActions,
};

const mutations = {
  ...cateringStore.mutations,
  ...usersStore.mutations,
  ...cateringMutations,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/catering/index.js